import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './stores/actionsList';
// import { Route, Switch } from "react-router-dom";

import i18n from 'i18next';
import { siteConfig } from './variables/config'
import { changeUrlWithLng, detectBrowser, getToken, getUserInfo, pathMaker } from './utils/useful'
import 'react-image-crop/src/ReactCrop.scss'

// import routes from './variables/routes'
// import Header from './components/Header'
// import Footer from './components/Footer';
// import TabBar from './components/TabBar';
import NotifManager from './components/NotifManager';
// import { initSocket, socket } from './utils/socket.services';

// import { io } from "socket.io-client";
// import ProtectedRoute from './components/ProtectedRoute';
// import { init } from './utils/init.services';
import Desktop from './pages/Desktop'
import { initDB } from './utils/db.service';

// import Modal from './components/Modal'
// import './App.css';


class App extends React.Component {

    state = {
        lngRoute: '',
        showPage: false
    }


    // socket = null
    componentDidMount() {

        this.initConfig()
        initDB()

        // this.checkUser(null, () => {
        //     init()
        // })




    }




    componentDidUpdate(e) {


        if (e.history.action === "PUSH" && this.state.prevLoc !== e.history.location) {
            window.scrollTo(0, 0)
            this.props.actions.changeSetting('lastLocation', this.state.prevLoc)
            this.setState({ prevLoc: e.history.location })
        }

        if (this.props.user.loggedin != e.user.loggedin && this.props.user.loggedin) {
            //    console.log("componentDidUpdate")
            //    console.log(this.props.user)
            //    console.log(e.user.loggedin)

            this.checkUser()
        }


    }





    initConfig() {
        // this.props.actions.changeSetting('hideTabBar', false)

        // SET LANGNGUAGE
        let parent = this
        i18n.on('languageChanged', (lng) => {
            this.setState({ showPage: false })

            if (siteConfig.forceUrl) {
                changeUrlWithLng(lng)
            }
            this.props.actions.changeLanguage('language', lng)
            this.setState({ showPage: true })
        })
        this.setSize()

        window.addEventListener('resize', this.setSize)

    }

    setSize = () => {
        let sizes = { isMobile: false, isTablet: false, isDesktop: false }
        let key = "isDesktop"
        let width = window.innerWidth
        if (width < 768 && width >= 576) {
            key = 'isTablet'
        }

        if (width < 576) {
            key = 'isMobile'
        }

        sizes[key] = true

        for (const [key, value] of Object.entries(sizes)) {
            this.props.actions.changeSetting(key, value)
        }

    }

    checkUser = (dontShowNotif, cb) => {
        setTimeout(() => {
            console.log("CHECK USER")
            // console.log(this.props.user.loggedin)
            // if (this.props.user.loggedin) {
            if (getToken()) {
                getUserInfo((data, err, status) => {
                    // console.log(data)
                    console.log(status)

                    if (status === 401) {
                        this.props.actions.forceLogoutUser()
                    }
                    if (status === 200 && data) {
                        // console.log("DFF")
                        if (data.authorized) {
                            // console.log(data.user)

                            this.props.actions.setUser(data.user, null, true)
                            setTimeout(() => {
                                if (cb) {
                                    cb()
                                }
                            }, 50);
                        } else {
                            this.props.actions.forceLogoutUser()
                        }
                    }

                    if (err) {
                        if (!dontShowNotif) {
                            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.cantConnectToServer', description: '{{lang}}errors.checkYourInternetConnection' })
                        }
                        this.props.actions.setUser({}, null, true)
                        setTimeout(() => {
                            this.checkUser(true, cb)
                        }, 10000);
                    }

                })
            } else {
                this.props.actions.forceLogoutUser()
                // this.props.history.push('/login')
            }
            // } else {
            //     if (!getToken()) {
            //         this.props.actions.forceLogoutUser()
            //     }
            // }
        }, 100);
    }


    defaultMaker() {
        if (siteConfig.forceUrl) {
            return siteConfig.dontShowUrlForDefaultLng ? (i18n.language === siteConfig.defaultLng ? '' : '/' + i18n.language) : '/' + i18n.language
        } else {
            return ''
        }
    }

    
    addNewWindow = (type, data, position) => {
        this.desktop.addNewWindow(type, data, position)
    }

    render() {

        let browser = detectBrowser()
        if (this.state.showPage) {
            return (
                <div className={"container-fluid default-theme m-0 p-0 " + (browser)} >

                    <NotifManager addNewWindow={this.addNewWindow}>

                        <div className="d-flex">

                            {/* {this.props.settings.showTabBar && (
                                <TabBar />
                            )} */}


                            <div style={{ width: '100%', position: 'relative' }}>

                                <Desktop ref={(el) => this.desktop = el} />
                                {/* {this.props.settings.showHeader && (
                                    <Header />
                                )} */}

                                {/* <div className="" style={{ minHeight: 'calc(100vh - 45px' }} >
                                    <Switch>
                                        {routes.map((prop, index) => {
                                            if (prop.protected) {

                                                return (
                                                    <ProtectedRoute prop={prop} key={index} exact={prop.exact} path={this.defaultMaker() + prop.path} component={prop.component} />
                                                )
                                            } else {

                                                return (
                                                    <Route key={index}
                                                        exact={prop.exact}
                                                        path={this.defaultMaker() + prop.path}
                                                        component={prop.component}
                                                    />
                                                )
                                            }
                                        })}
                                    </Switch>
                                </div> */}

                                {/* {this.props.settings.showFooter && (
                                    <Footer />
                                )} */}
                            </div>


                        </div>


                    </NotifManager>


                </div>
            )
        } else {
            return (<div></div>)
        }

    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);